/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { boolean as codecBoolean, number as codecNumber, optional as codecOptional, } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { UpdateSuiteAutoTestBaseData } from './UpdateSuiteAutoTestBaseData';
const UpdateSuiteAutoTestDataParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['id', /* #__PURE__ */ codecOptional(codecNumber)],
    [
        'submissionInfo',
        /* #__PURE__ */ codecOptional(codecBoolean),
        'submission_info',
    ],
    [
        'commandTimeLimit',
        /* #__PURE__ */ codecOptional(parsers.duration),
        'command_time_limit',
    ],
]), UpdateSuiteAutoTestBaseData);
export class UpdateSuiteAutoTestData extends UpdateSuiteAutoTestBaseData {
    static decode(input) {
        return UpdateSuiteAutoTestDataParser.decode(input).map(res => new UpdateSuiteAutoTestData(res));
    }
    static unsafeDecode(input) {
        return UpdateSuiteAutoTestData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return UpdateSuiteAutoTestDataParser.encode(data);
    }
    static schema() {
        return UpdateSuiteAutoTestDataParser.schema();
    }
}
